import en from './en.json'
import it from './it.json'

export const exportsTranslations = {
	en,
	it
} as const
